import styled from "styled-components"
import { colors } from "../../themes/colors"

export const CareTeamTherapistsPageBody = styled.main`
  background: ${colors.c_white[500]};
`
